const publicUrl = {
  namespaced: true,
  state: {
    mockPublicUrl: "",
  },
  mutations: {
    SET_PUBLIC_URL(state, payload) {
      state.mockPublicUrl = payload.mockPublicUrl || "";
    },
  },
};

export default publicUrl;
